export const ActionTypes = {
  GET_TRANSCRIPTION_LIST: "GET_TRANSCRIPTION_LIST",
  RESET_STATE: 'RESET_STATE'
};
